'use client';

import React, { memo, useMemo } from 'react';
import Image from 'next/image';

interface AppLogoProps {
  src?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const DEFAULT_LOGO = '/assets/images/kasnimo-logo.png';

const AppLogo = memo(function AppLogo({
  src = DEFAULT_LOGO,
  size = 32,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div className={containerClassName} onClick={onClick}>
      <Image
        src={src}
        alt="Kasnimo"
        width={size}
        height={size}
        className="flex-shrink-0 object-contain rounded-lg"
        priority={true}
        unoptimized={true}
      />
    </div>
  );
});

export default AppLogo;
